import { FC, PropsWithChildren } from 'react';
import { Props as NotifyListPartyProps } from 'components/service/NotifyList/NotifyListParty';
import { NotifyStatusBar } from 'components/service/party/partyRedesignCard/NotifyStatusBar';
import { partyCardCssDefs } from 'components/service/party/partyRedesignCard/partyCardCssDefs';
import { useIsCompactView } from 'hooks/useIsCompactView';
import PartyRedesignBody from 'components/service/party/PartyRedesignBody';

/**
 * This is a fork/variation of PartyRedesignCard that is used as a drop-in replacement
 * for the NotifyListParty component. It is used for items in the "Requests" waitlist section.
 */
const PartyRedesignNotifyCard: FC<PropsWithChildren<NotifyListPartyProps>> = ({
  item,
  onClick,
}) => {
  const isCompactView = useIsCompactView();
  return (
    <div css={partyCardCssDefs.partyCard({ isSelected: false, isDragging: false, isCompactView })}>
      <NotifyStatusBar state={item.state} />
      <PartyRedesignBody
        isSelected={false}
        onClick={() => onClick(item.id)}
        party={item}
        hideStatusBar
      />
      {/* Since assignment isn't enabled for the *NotifyCard case we don't render a PartyRedesignStatusIndicator */}
    </div>
  );
};

export default PartyRedesignNotifyCard;
